export default "__VITE_ASSET__0d778d3d__"